import styles from './index.module.css';

interface Props {
  label?: React.ReactNode;
}

const LoadingBar: React.FC<Props> = ({ label = 'Loading...' }) => {
  return (
    <div className={styles.LoadingCentered}>
      <div className={styles.LoadingBarLabel}>{label}</div>
      <div className={styles.LoadingBase}>
        <div className={styles.LoadingBar} />
      </div>
    </div>
  );
};

export default LoadingBar;
